export const messages = {
  en: {
    reportCustomComponentManage: {
      queryCondition: 'Query Conditions',
      inputComponentId: 'Please input component ID',
      inputComponentName: 'Please input component name',
      selectComponentType: 'Please select component type',
      query: 'Query',
      reset: 'Reset',
      reportComponents: 'Report Components',
      add: 'Add',
      componentId: 'Component ID',
      componentName: 'Component Name',
      componentType: 'Component Type',
      queryMethod: 'Query Method',
      description: 'Description',
      operation: 'Operation',
      setCondition: 'Set Condition',
      footerStatistics: 'Footer Statistics',
      edit: 'Edit',
      delete: 'Delete',
      table: 'Table',
      pieChart: 'Pie Chart',
      input: 'Input',
      select: 'Select',
      date: 'Date',
      requiredComponentName: 'Component name is required',
      maxLength64: 'Cannot exceed 64 characters',
      requiredComponentType: 'Component type is required',
      requiredQueryMethod: 'Query method is required',
      inputSql: 'Optional, please input SQL',
      inputJavaScript: 'Optional, please input JavaScript',
      inputDescription: 'Optional, please input description',
      cancel: 'Cancel',
      save: 'Save',
      confirmOperation: 'Please confirm your operation',
      confirmDeleteComponent: 'Are you sure to delete this report component?',
      confirmDelete: 'Confirm Delete',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    reportCustomComponentManage: {
      queryCondition: '查询条件',
      inputComponentId: '请输入组件ID',
      inputComponentName: '请输入组件名称',
      selectComponentType: '请选择组件类型',
      query: '查询',
      reset: '重置',
      reportComponents: '报表组件',
      add: '添加',
      componentId: '组件ID',
      componentName: '组件名称',
      componentType: '组件类型',
      queryMethod: '查询方式',
      description: '描述',
      operation: '操作',
      setCondition: '设置条件',
      footerStatistics: '底部统计',
      edit: '修改',
      delete: '删除',
      table: '表格',
      pieChart: '饼状图',
      input: '输入框',
      select: '下拉框',
      date: '日期',
      requiredComponentName: '组件名称不能为空',
      maxLength64: '不能超过64个字符',
      requiredComponentType: '组件类型不能为空',
      requiredQueryMethod: '查询方式不能为空',
      inputSql: '选填，请填写执行SQL',
      inputJavaScript: '选填，请填写执行JavaScript',
      inputDescription: '选填，请填写描述',
      cancel: '取消',
      save: '保存',
      confirmOperation: '请确认您的操作',
      confirmDeleteComponent: '确定删除该报表组件吗？',
      confirmDelete: '确认删除',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功'
    }
  }
}